import { svgs } from 'constants'
import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <React.Fragment>
      <header className='header bg-gradient'>
        <div className='logo-container px-4'>
          {svgs.w_sport_adda}
          <Link to={'/'}>{svgs.w_sport_adda_2}</Link>
        </div>
      </header>
      <div className="news-marquee">
        <div className='px-2'>
          {svgs.mic}
        </div>

        <marquee behavior="" direction="">
          Our Exchange features 🏏 Cricket, ⚽ Soccer, 🎾 Tennis, 🏆 Cup winners, Elections, 🎰🎲 International Casinos, 🐎Horse Racing, 🦮 Animal Racing, and many more games.
        </marquee>
      </div>
    </React.Fragment>
  )
}

export default Header